export default __webpack_public_path__ + "static/media/medium_rectangle_300.9b842e8a.png";